import React from 'react';
import { useSystem } from '../context/SystemContext';
import FeatureDisabled from './FeatureDisabled';

// Maps route path prefixes to feature flag keys + friendly names
const ROUTE_FEATURE_MAP = [
  { path: '/shop',     flag: 'shopEnabled',           name: 'Shop' },
  { path: '/product',  flag: 'shopEnabled',           name: 'Shop' },
  { path: '/checkout', flag: 'checkoutEnabled',       name: 'Checkout' },
  { path: '/cart',     flag: 'checkoutEnabled',       name: 'Checkout' },
  { path: '/recipes',  flag: 'recipesEnabled',        name: 'Recipes' },
  { path: '/register', flag: 'registrationEnabled',   name: 'New Registrations' },
];

const FeatureGate = ({ children }) => {
  const flags = useSystem();
  const pathname = window.location.pathname;

  const blocked = ROUTE_FEATURE_MAP.find(
    r => pathname === r.path || pathname.startsWith(r.path + '/')
  );

  if (blocked && flags[blocked.flag] === false) {
    return <FeatureDisabled feature={blocked.name} />;
  }

  return children;
};

export default FeatureGate;